import React from 'react';

const AddPersonModal = ({ show, onClose, nomePessoa, setNomePessoa, telefonePessoa, setTelefonePessoa, cpfCnpjPessoa, setCpfCnpjPessoa, cadastrarPessoa }) => {
  if (!show) return null;

  return (
    <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog" aria-labelledby="addPersonModalLabel" aria-hidden="true">
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <form onSubmit={cadastrarPessoa}>
            <div className="modal-header">
              <h5 className="modal-title" id="addPersonModalLabel">Nova Pessoa</h5>
              <button type="button" className="close" onClick={onClose} aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <label className="required" htmlFor="nomePessoa">Nome</label>
              <input
                id="nomePessoa"
                className='form-control'
                name='nome'
                value={nomePessoa}
                onChange={(e) => setNomePessoa(e.target.value)}
                required
              />
              <label className="required" htmlFor="telefonePessoa">Telefone</label>
              <input
                id="telefonePessoa"
                value={telefonePessoa}
                className='form-control'
                name="telefone"
                maxLength={14}
                onChange={(e) => setTelefonePessoa(e.target.value)}
                required
              />
              <label htmlFor="cpfCnpjPessoa">CPF/CNPJ</label>
              <input
                id="cpfCnpjPessoa"
                maxLength={18}
                className='form-control'
                name="cpf_cnpj"
                value={cpfCnpjPessoa}
                onChange={(e) => setCpfCnpjPessoa(e.target.value)}
              />
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose}>Fechar</button>
              <button type="submit" className="btn btn-primary">Salvar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddPersonModal;
